import { ImageBlock as ImageBlockComponent } from "@moim/blockit";
import shortid from "shortid";
import * as React from "react";

export const ImageBlock: React.FC<
  Moim.Blockit.V2.IImageBlock & { className?: string }
> = props => {
  const [uniqueId] = React.useState(shortid.generate());
  // const { openSrcImageBrochure } = useActions({
  //   openSrcImageBrochure: ImageBrochureActionCreators.openSrcImageBrochure,
  // });

  const handleClick = React.useCallback<
    React.MouseEventHandler<HTMLImageElement>
  >(
    e => {
      if (!props.href && props.enableDetailShow) {
        const target = e.currentTarget;
        if (target) {
          target.dataset.brochureSelected = "true";
          // openSrcImageBrochure(props.src);
        }
      }
    },
    [props.href, props.src, props.enableDetailShow],
  );

  return (
    <ImageBlockComponent
      {...props}
      onClick={handleClick}
      imageProps={{
        "data-role": props.enableDetailShow
          ? `brochure-thumbnail-${uniqueId}`
          : undefined,
      }}
    />
  );
};
